<template>
  <div class="d-flex justify-content-center" id="modal-mailreset">
    <div v-if="automaticKey" class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="m-portlet__head modal-resetpass-title">
          <h3 class="m-portlet__head-text">{{$t("message.search_reset_pass_tooltip")}}</h3>
        </div>
        <hr class="w-100 mt-0 mb-0"/>
        <form name="form.resetPass" action @submit.prevent="passwordChangeMail()">
          <div class="email-pass-container">
            <label class="m-checkbox m-checkbox--bold m-checkbox--state-success mt-3 mb-5 checkbox-text">
              <input
                data-vs-input="key-input"
                :value="automaticKey"
                v-model="automaticKey"
                id="automaticKey"
                @click="changeKey" type="checkbox"
              />
              {{$t("message.checkbox_reset_pass_tooltip")}}
              <span></span>
            </label>
            <div class="group-reset-mail">
              <input
                data-vs-input="email"
                class="reset-mail-input" type="text" id="resetPass.mail" v-validate="'required|email'"
                name="mail" required v-model="email">
              <span class="highlight"></span>
              <span class="bar mt-1"></span>
              <label class="reset-mail-label">{{$t("message.ei_titleList_text_2_2")}}</label>
            </div>
            <div>
              <p class="m--font-danger" v-for="error in errors.collect('mail')">{{ error }}</p>
            </div>
          </div>
          <h5 class="m-portlet__head-text modal-resetpass-subtitle">
            {{$t("message.employees_list_modal_reset_subtitle")}}</h5>
          <div class="d-flex m-3 h-12">
            <button data-vs-button="clear-fields" type="button" @click="clearFields" data-dismiss="modal" class="btn btn-secondary mr-3 w-100">{{$t("message.cancel")}}</button>
            <button data-vs-button="submit" v-if="!loadingMail" :disabled="errors.any()" type="submit" class="btn btn-primary w-100">{{$t("message.login_send")}}</button>
            <button data-vs-button="submit" v-if="loadingMail" type="submit" class="btn btn-primary w-100"><div class="m-loader m-loader--light"></div></button>
          </div>
        </form>
      </div>
    </div>
    <div v-else class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="m-portlet__head modal-resetpass-title">
          <h3 class="m-portlet__head-text">{{$t("message.search_reset_pass_tooltip")}}</h3>
        </div>
        <hr class="w-100 mt-0 mb-0"/>
        <form data-vs-form="form-new-pass" name="form.newpass" action @submit.prevent="passwordChange()">
          <div class="email-pass-container">
            <label class="m-checkbox m-checkbox--bold m-checkbox--state-success mt-3 mb-4 checkbox-text">
              <input data-vs-input="change-key-input" :value="automaticKey" v-model="automaticKey" id="automaticKey" @click="changeKey" type="checkbox" />
              {{$t("message.checkbox_reset_pass_tooltip")}}
              <span></span>
            </label>
            <div class="mt-2 d-flex">
              <div class="group-reset-mail w-100">
                <input data-vs-input="reset-password-input" class="reset-mail-input" type="password" id="pass" v-validate="'required'" name="pass" required v-model="pass" ref="pass">
                <span class="highlight"></span>
                <span class="bar"></span>
                <label class="reset-mail-label">{{$t('message.login_first_login_password_field_label')}}</label>
              </div>
              <div v-if="(!$browserDetect.isIE) && (!$browserDetect.isEdge)" class="eye c-pointer" @click="showPassword('pass')"></div>
            </div>
            <div>
              <p class="m--font-danger" v-for="error in errors.collect('pass')">{{ error }}</p>
            </div>
            <div class="mt-4 mb-2 d-flex">
              <div class="group-reset-mail w-100">
                <input data-vs-input="reset-password-confirm" class="reset-mail-input" type="password" id="repass" v-validate="'required|confirmed:pass'" name="repass" required v-model="repass">
                <span class="highlight"></span>
                <span class="bar"></span>
                <label class="reset-mail-label">{{$t('message.confirm_password')}}</label>
              </div>
              <div v-if="(!$browserDetect.isIE) && (!$browserDetect.isEdge)" class="eye c-pointer" @click="showPassword('repass')"></div>
            </div>
            <div>
              <p class="m--font-danger" v-for="error in errors.collect('repass')">{{ error }}</p>
            </div>
          </div>
          <div class="buttons-container d-flex justify-content-center">
            <button data-vs-button="clear-fields-password" type="button" @click="clearFields" data-dismiss="modal" class="btn btn-secondary m-3 w-100">{{$t("message.cancel")}}</button>
            <button data-vs-button="submit-new-password" v-if="!loadingReset" :disabled="errors.any()" type="submit" class="btn btn-primary m-3 w-100">{{$t("message.login_send")}}</button>
            <button data-vs-button="submit-new-password" v-if="loadingReset" type="submit" class="btn btn-primary m-3 w-100"><div class="m-loader m-loader--light"></div></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>

import User from '../../../apiClient/User';
import UserManagement from '../../../apiClient/UserManagement';

export default {

  props: {
    email: String,
    automaticKey: Boolean,
  },
  data (){
    return {
      userClient: User,
      userNew: UserManagement,
      user:'',
      pass:'',
      repass:'',
      showPass:false,
      loadingMail: false,
      loadingReset: false,
      email: this.email
    }
  },
  created(){
    this.userClient = new User();
    this.userNew = new UserManagement();
  },

  methods: {
    clearFields (){
      this.pass = '';
      this.repass = '';
      this.email = '';
    },
    showPassword(id) {
      if (this.showPass) {
        this.showPass = false;
        document.getElementById(id).setAttribute("type", "password");
      } else {
        this.showPass = true;
        document.getElementById(id).setAttribute("type", "text");
      }
    },
    changeKey(){
      if (!this.automaticKey) {
        this.email = ''
        this.userClient
          .getinfoEmployee(this.$route.params.id)
          .then(res => {
            if (res.status === 200) {
              this.email = res.data.mail;
            }
          })
          .catch(error => {
            console.log(error);
          })
      }
      else {
        this.pass = '';
        this.repass = '';
      }
    },
    passwordChangeMail() {
      this.$validator.validate().then(result => {
        if (result) {
          this.loadingMail = true;
          this.userClient.getinfoEmployee(this.$route.params.id)
            .then(result => {
              if (result.status === 200) {
                this.user = result.data.usuario;
                this.userNew.changeUserMail(this.$route.params.id, this.email)
                  .then(resp => {
                    if (resp.status === 200) {
                      this.userClient
                        .resetPassRequest(this.user, this.email)
                        .then(res => {
                          if (res.status === 200) {
                            this.loadingMail = false;
                            swal({
                              type: "success",
                              title: `${this.$t("message.employee_edit_success")}`,
                              showConfirmButton: true,
                              confirmButtonText: `${this.$t(
                                  "message.billboard_form_post_button_confirm"
                              )}`
                            }).then(() => {
                              this.$emit('mailChanged', this.email);
                              $('#resetModal').modal('hide');
                            });
                          }
                        })
                        .catch(error => {
                          if (error.response.status === 400) {
                            let errors = error.response.data.results;
                            console.log(errors);
                            this.loadingMail = false;
                            swal({
                              type: "error",
                              title: `${this.$t("message.actions.error")}`,
                              text: `${this.$t("message.employees_list_modal_reset_pass_incorrect")}`,
                              showConfirmButton: true,
                              confirmButtonText: `${this.$t("message.billboard_form_post_button_confirm")}`
                            });
                          }
                        });
                    }
                  })
                  .catch(error => {
                    this.loadingMail = false;
                    swal({
                      type: 'error',
                      title: `${this.$t("message.employees_list_modal_reset_pass_incorrect_change")}`,
                      showConfirmButton: true,
                      confirmButtonText: `${this.$t("message.billboard_form_post_button_confirm")}`
                    }).then(() => {

                    });
                  });
              }
            })
            .catch(error => {
              console.log(error);
            })
        }
      });
    },
    passwordChange() {
      this.$validator.validate().then(result => {
        if (result) {
          this.loadingReset = true;
          this.userClient
            .changePassUser(this.$route.params.id, this.pass, this.repass)
            .then(res => {
              if (res.status === 200) {
                this.loadingReset = false;
                swal({
                  type: "success",
                  title: `${this.$t("message.msj_success_modify_user")}`,
                  showConfirmButton: true,
                  confirmButtonText: `${this.$t(
                      "message.billboard_form_post_button_confirm"
                  )}`
                }).then(() => {
                  this.pass = '';
                  this.repass = '',
                      $('#resetModal').modal('hide');
                });
              }
            })
            .catch(error => {
              if (error.response.status === 400) {
                this.loadingReset = false;
                let errors = error.response.data.results.data[0];
                swal({
                  type: "error",
                  title: `${this.$t("message.actions.error")}`,
                  text: errors,
                  showConfirmButton: true,
                  confirmButtonText: `${this.$t(
                      "message.billboard_form_post_button_confirm"
                  )}`
                });
              }
            });
        }
      });
    },
  }
}
</script>

<style scoped lang="scss">
@import "./public/assets/scss/components/_resetpass.scss";
</style>
